module.exports = __webpack_public_path__ + "static/img/logo.a027b50.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/logo.svg
// module id = AqYs
// module chunks = 68